const SvgAutomation1 = (props) => (
  <>
    <path transform="rotate(-45 192 192.001)" d="M56.24 56.24h271.53v271.53H56.24z" fill={props.p10} />
  </>
);

export default SvgAutomation1;
